import { LocaleSchema, type Locale } from "@iso27001/shared";

export const DEFAULT_LOCALE: Locale = "de";

export interface LocaleInputs {
  /** The signed-in user's stored preference, or null if never chosen. */
  userLocale: Locale | null;
  /** A previously remembered choice from this browser, or null. */
  stored: string | null;
  /** navigator.language, or an Accept-Language header value. */
  acceptLanguage: string | null;
}

/**
 * Resolution order: the signed-in user's stored choice, then this browser's
 * remembered choice, then the browser's own languages, then German.
 *
 * German is last because it is the default, not because it is least preferred:
 * the ISMS, its documents and its auditors are German, and English is the
 * accommodation.
 */
export function resolveLocale({ userLocale, stored, acceptLanguage }: LocaleInputs): Locale {
  if (userLocale) return userLocale;

  const remembered = LocaleSchema.safeParse(stored);
  if (remembered.success) return remembered.data;

  for (const tag of (acceptLanguage ?? "").split(",")) {
    // "en-GB;q=0.9" -> "en"
    const primary = tag.trim().split(";")[0]?.split("-")[0]?.toLowerCase();
    const parsed = LocaleSchema.safeParse(primary);
    if (parsed.success) return parsed.data;
  }

  return DEFAULT_LOCALE;
}
